// ============================================================================
// ENGINE DE BUSCA LOCAL (TOKENIZER)
// OBJETIVO: Gerar palavras-chave para permitir busca 'partial match' no Firestore.
// ============================================================================

export const SearchEngine = {
    // Gera array de sufixos/prefixos para busca
    // Ex: "Silva" -> ["s", "si", "sil", "silv", "silva"]
    generateKeywords: (text) => {
        if (!text) return [];
        const cleanText = text.toLowerCase().trim();
        const words = cleanText.split(/\s+/); // Divide por espaços
        const keywords = new Set(); // Set para evitar duplicatas

        // 1. Gera tokens para cada palavra individualmente
        words.forEach(word => {
            let temp = '';
            for (const char of word) {
                temp += char;
                keywords.add(temp);
            }
        });

        // 2. Adiciona o texto completo limpo
        keywords.add(cleanText);

        return Array.from(keywords);
    },

    // Gera keywords combinadas para um Cliente
    createClientIndex: (clientData) => {
        const name = clientData.qualification?.physical?.name || clientData.qualification?.legal?.companyName || '';
        const email = clientData.contact?.email || '';
        const doc = clientData.qualification?.physical?.cpf || clientData.qualification?.legal?.cnpj || '';
        
        // Junta tudo num array único de busca
        const allTerms = [
            ...SearchEngine.generateKeywords(name),
            ...SearchEngine.generateKeywords(email.split('@')[0]), // Apenas usuário do email
            doc.replace(/\D/g, '') // Documento limpo
        ];
        
        return [...new Set(allTerms)]; // Remove duplicatas
    },

    // Gera keywords para um Processo
    createProcessIndex: (processData) => {
        const cnj = processData.numeroCNJ || '';
        const client = processData.clientName || '';
        const opponent = processData.parteContraria || '';
        
        const allTerms = [
            ...SearchEngine.generateKeywords(client),
            ...SearchEngine.generateKeywords(opponent),
            cnj.replace(/\D/g, '') // CNJ limpo para busca exata
        ];

        return [...new Set(allTerms)];
    }
};